export default __webpack_public_path__ + "static/media/roulette_banner.b1f6730f.png";